{
  "ticket": {
    "title": "Tickets de support",
    "subtitle": "File de support client",
    "columns": {
      "id": "ID ticket",
      "subject": "Sujet",
      "merchant": "Marchand",
      "assignee": "Assigné à",
      "priority": "Priorité",
      "status": "Statut",
      "category": "Catégorie",
      "createdAt": "Créé le",
      "updatedAt": "Mis à jour",
      "sla": "SLA"
    },
    "actions": {
      "create": "Nouveau ticket",
      "assign": "Assigner",
      "reassign": "Réassigner",
      "close": "Fermer",
      "reopen": "Rouvrir",
      "reply": "Répondre",
      "addNote": "Ajouter une note interne",
      "escalate": "Escalader"
    },
    "filters": {
      "status": "Statut",
      "priority": "Priorité",
      "category": "Catégorie",
      "assignee": "Assigné à",
      "overdue": "En retard uniquement",
      "search": "Rechercher des tickets"
    },
    "empty": {
      "title": "Aucun ticket",
      "body": "Aucun ticket ne correspond à vos filtres."
    },
    "errors": {
      "loadFailed": "Échec du chargement des tickets",
      "assignFailed": "Échec de l'assignation du ticket"
    },
    "detail": {
      "conversation": "Conversation",
      "history": "Historique",
      "attachments": "Pièces jointes",
      "relatedOrders": "Commandes liées",
      "merchantInfo": "Infos marchand"
    }
  },
  "ticket_status": {
    "open": "Ouvert",
    "inProgress": "En cours",
    "waitingCustomer": "En attente du client",
    "waitingVendor": "En attente du vendeur",
    "resolved": "Résolu",
    "closed": "Fermé"
  },
  "ticket_priority": {
    "low": "Basse",
    "normal": "Normale",
    "high": "Haute",
    "urgent": "Urgente"
  },
  "ticket_category": {
    "order": "Problème de commande",
    "shipping": "Expédition",
    "payment": "Paiement",
    "product": "Qualité du produit",
    "account": "Compte",
    "technical": "Technique",
    "other": "Autre"
  },
  "sla": {
    "label": "SLA",
    "withinSla": "Dans le SLA",
    "approachingSla": "SLA bientôt dépassé",
    "breached": "SLA dépassé",
    "timeRemaining": "Temps restant : {{time}}",
    "timeOverdue": "En retard de : {{time}}"
  },
  "dashboard": {
    "title": "Tableau de bord support",
    "subtitle": "KPI et performance des agents",
    "kpis": {
      "openTickets": "Tickets ouverts",
      "avgResponseTime": "Temps de réponse moyen",
      "avgResolutionTime": "Temps de résolution moyen",
      "slaCompliance": "Conformité SLA",
      "slaBreaches": "Dépassements SLA (24h)",
      "satisfaction": "Score CSAT"
    },
    "charts": {
      "ticketsOverTime": "Tickets dans le temps",
      "categoryBreakdown": "Répartition par catégorie",
      "priorityBreakdown": "Répartition par priorité",
      "agentLoad": "Charge des agents"
    },
    "agentTable": {
      "title": "Performance des agents",
      "columns": {
        "agent": "Agent",
        "active": "Actifs",
        "resolved24h": "Résolus (24h)",
        "avgResponse": "Réponse moy.",
        "csat": "CSAT"
      }
    },
    "filters": {
      "dateRange": "Plage de dates",
      "team": "Équipe"
    }
  },
  "statusLabels": {
    "Open": "Ouvert",
    "InProgress": "En cours",
    "In Progress": "En cours",
    "AwaitingHandler": "En attente du responsable",
    "PendingSupportReview": "En attente de synthèse support",
    "Resolved": "Résolu",
    "Closed": "Fermé",
    "Reopened": "Rouvert"
  },
  "originLabels": {
    "merchant": "Ouvert par le marchand",
    "vendor": "Ouvert par le fournisseur",
    "admin": "Ouvert par l'admin"
  },
  "deptQueue": {
    "title": "File des dispatches par service",
    "loading": "Chargement…",
    "empty": "Aucun dispatch pour ce service.",
    "colTicket": "Ticket parent",
    "colStatus": "Statut",
    "colScopeNote": "Résumé",
    "colCreatedAt": "Créé le",
    "openTicket": "Ouvrir le ticket"
  },
  "priorityLabels": {
    "Critical": "Critique",
    "High": "Haute",
    "Medium": "Moyenne",
    "Low": "Basse"
  },
  "categoryLabels": {
    "Order": "Commande",
    "Billing": "Facturation",
    "Product": "Produit",
    "Account": "Compte",
    "General": "Général"
  },
  "bugStatusLabels": {
    "open": "Ouvert",
    "in_progress": "En cours",
    "resolved": "Résolu",
    "closed": "Fermé"
  },
  "bugPriorityLabels": {
    "low": "Basse",
    "medium": "Moyenne",
    "high": "Haute",
    "critical": "Critique"
  },
  "ticketsPage": {
    "heading": "Tickets de support",
    "subtitle": "File de tickets par SLA, priorité et catégorie.",
    "totalCount": "{{total}} tickets",
    "forbidden": "Vous n'avez pas la permission de consulter les tickets de support.",
    "loadError": "Échec du chargement de la liste des tickets.",
    "tablistAria": "Statut du ticket",
    "tableAria": "Liste des tickets de support",
    "tabs": {
      "all": "Tous",
      "open": "Ouverts",
      "inProgress": "En cours",
      "resolved": "Résolus",
      "closed": "Fermés",
      "reopened": "Rouverts"
    },
    "columns": {
      "id": "ID",
      "subject": "Sujet",
      "merchant": "Marchand",
      "priority": "Priorité",
      "status": "Statut",
      "sla": "SLA",
      "assignee": "Assigné à",
      "createdAt": "Créé le"
    },
    "loading": "Chargement…",
    "empty": "Aucun ticket ne correspond aux filtres actuels.",
    "rows": "Lignes",
    "rowsPerPageAria": "Lignes par page",
    "merchantFallback": "Marchand {{id}}",
    "unassigned": "Non assigné"
  },
  "ticketDetail": {
    "missingId": "ID de ticket manquant dans l'URL.",
    "backToList": "Retour à la liste",
    "back": "Tickets",
    "loadError": "Impossible de charger les détails du ticket : {{message}}",
    "unknownError": "Erreur inconnue.",
    "updateSuccess": "Ticket mis à jour",
    "updateFailTitle": "Échec de la mise à jour",
    "escalatedBadge": "Escaladé · Niveau {{level}}",
    "escalateBtn": "Escalader",
    "createdAt": "Créé {{time}}",
    "requesterLabel": "Demandeur :",
    "firstResponseLabel": "Première réponse :",
    "resolutionLabel": "Résolution :",
    "categoryLabel": "Catégorie :",
    "description": "Description",
    "attachments": "Pièces jointes",
    "transitions": {
      "start": "Commencer le traitement",
      "markResolved": "Marquer comme résolu",
      "close": "Fermer le ticket",
      "reopen": "Rouvrir"
    }
  },
  "slaWarning": {
    "aria": "Alerte SLA",
    "firstResponseTitle": "SLA : Réponse en retard",
    "resolutionTitle": "SLA : Résolution en retard",
    "respondBy": "Répondre avant : {{time}}",
    "resolveBy": "Résoudre avant : {{time}}",
    "firstResponseAction": "Réponse en retard — Action immédiate requise",
    "resolutionAction": "Résolution en retard — Action immédiate requise"
  },
  "supportDashboard": {
    "forbiddenTitle": "Accès refusé",
    "forbiddenBody": "Votre compte n'a pas la permission de consulter les rapports de support.",
    "heading": "Tableau de bord support",
    "kpiAria": "KPI du support",
    "chartsAria": "Graphiques du support",
    "kpi": {
      "open": "Tickets ouverts",
      "overdue": "En retard",
      "avgResponse": "Première réponse moy.",
      "resolvedToday": "Résolus aujourd'hui"
    },
    "slaChartTitle": "Conformité SLA par priorité",
    "volumeChartTitle": "Volume par catégorie",
    "agentSectionTitle": "Performance des agents",
    "empty": "Aucun ticket pour le moment.",
    "error": "Impossible de charger les données du support — nouvelle tentative."
  },
  "conversation": {
    "sectionAria": "Conversation du ticket",
    "tablistAria": "Type de message",
    "tabs": {
      "public": "Marchand",
      "internal": "Notes internes"
    },
    "internalBadge": "Interne",
    "internalBanner": "Les notes internes ne comptent pas pour le SLA et ne sont pas envoyées au client.",
    "emptyPublic": "Aucun message public pour le moment.",
    "emptyInternal": "Aucune note interne pour le moment.",
    "dispatchButton": "Transférer"
  },
  "replyBox": {
    "sectionAria": "Composer une réponse",
    "heading": "Répondre",
    "typeLabel": "Type",
    "type": {
      "public": "Public (envoyé au client)",
      "internal": "Interne (admins uniquement)"
    },
    "placeholderPublic": "Rédigez une réponse au client.",
    "placeholderInternal": "Note interne — le client ne la voit pas.",
    "removeAttachment": "Retirer {{filename}}",
    "uploading": "Téléversement...",
    "attach": "Joindre un fichier",
    "sending": "Envoi...",
    "send": "Envoyer",
    "uploadFailTitle": "Impossible de téléverser la pièce jointe",
    "emptyContentTitle": "Aucun contenu",
    "emptyContentBody": "Veuillez saisir un contenu avant d'envoyer.",
    "sentNoteTitle": "Note interne ajoutée",
    "sentReplyTitle": "Réponse envoyée",
    "sendFailTitle": "Échec de l'envoi",
    "unknownError": "Erreur inconnue.",
    "internalToggle": "Note interne (support uniquement)"
  },
  "infoSidebar": {
    "aside": "Infos du ticket",
    "statusSection": "Statut",
    "statusLabel": "Statut",
    "priorityLabel": "Priorité",
    "assigneeLabel": "Assigné à",
    "escalated": "Escaladé au niveau {{level}}",
    "relatedOrders": "Commandes liées",
    "noRelatedOrders": "Aucune commande liée pour le moment.",
    "activity": "Activité",
    "noActivity": "Aucune activité enregistrée pour le moment.",
    "system": "Système"
  },
  "assigneePicker": {
    "unassigned": "— Non assigné —",
    "searchPlaceholder": "Rechercher par nom ou e-mail…",
    "noMatch": "Aucun admin trouvé correspondant à \"{{query}}\"."
  },
  "slaBadge": {
    "overdue": "En retard",
    "now": "maintenant",
    "closed": "Fermé",
    "closedAria": "Ticket fermé",
    "unknown": "SLA inconnu",
    "leftDaysHours": "{{days}}j {{hours}}h restantes",
    "leftDays": "{{days}}j restants",
    "leftHoursMins": "{{hours}}h {{mins}}m restantes",
    "leftHours": "{{hours}}h restantes",
    "leftMins": "{{mins}}m restantes",
    "ariaOverdue": "SLA en retard de {{mins}} minutes",
    "ariaRemaining": "SLA {{copy}}"
  },
  "listFilters": {
    "regionAria": "Filtres de la liste des tickets de support",
    "priorityLabel": "Priorité",
    "priorityAria": "Filtrer par priorité",
    "categoryLabel": "Catégorie",
    "categoryAria": "Filtrer par catégorie",
    "assigneeLabel": "Assigné à",
    "assigneeAria": "Filtrer par assigné",
    "all": "Tous",
    "assigneeAll": "Assigné (tous)",
    "unassigned": "Non assigné",
    "overdue": "En retard",
    "searchPlaceholder": "Rechercher par ID ou sujet…",
    "searchAria": "Rechercher des tickets par ID ou sujet"
  },
  "escalate": {
    "title": "Escalader le ticket",
    "modeLegend": "Comment choisir l'admin",
    "modeRoundRobin": "Round-robin (assignation auto à l'admin de garde)",
    "modePick": "Choisir un admin précis",
    "pickLabel": "Admin destinataire",
    "pickPlaceholder": "— Choisir un admin —",
    "slaLabel": "Nouveau SLA (heures)",
    "slaHint": "Par défaut {{hours}} heures.",
    "noteLabel": "Note",
    "notePlaceholder": "Raison de l'escalade (enregistrée dans le journal d'audit).",
    "cancel": "Annuler",
    "confirm": "Confirmer l'escalade",
    "sending": "Envoi...",
    "noAdminTitle": "Aucun admin sélectionné",
    "noAdminBody": "Veuillez sélectionner un admin pour l'escalade.",
    "noNoteTitle": "Raison manquante",
    "noNoteBody": "Veuillez saisir une note pour l'escalade.",
    "invalidSlaTitle": "SLA invalide",
    "invalidSlaBody": "Le SLA doit être un nombre d'heures positif.",
    "successTitle": "Ticket escaladé",
    "failTitle": "Impossible d'escalader",
    "unknownError": "Erreur inconnue."
  },
  "agentTable": {
    "empty": "Aucun agent n'a encore traité de tickets.",
    "columns": {
      "agent": "Agent",
      "open": "Ouverts",
      "avgResponse": "Première réponse moy.",
      "resolutionRate": "Taux de résolution"
    }
  },
  "charts": {
    "sla": {
      "empty": "Aucun ticket à évaluer pour le SLA.",
      "aria": "Conformité SLA par priorité",
      "met": "Respecté",
      "missed": "Manqué"
    },
    "volume": {
      "empty": "Aucun ticket à catégoriser.",
      "aria": "Volume de tickets par catégorie"
    }
  },
  "bugTracker": {
    "title": "Bug Tracker",
    "forbiddenBody": "Vous n'avez pas la permission d'accéder au Bug Tracker. Cette page est réservée au Super Admin.",
    "saLock": "Super Admin uniquement",
    "subtitle": "Gérez les rapports de bugs — glissez-déposez une carte vers une autre colonne pour changer son statut. Toutes les erreurs runtime de l'admin SPA sont automatiquement envoyées ici (auto-reported).",
    "autoBannerText": "erreurs auto-reported sur les 7 derniers jours. Activez le filtre « Auto-reported uniquement » pour les voir séparément.",
    "viewToggleAria": "Basculer la vue",
    "viewKanban": "Kanban",
    "viewTable": "Tableau",
    "severity": "Gravité",
    "all": "Tous",
    "autoOnly": "Auto-reported uniquement",
    "search": "Rechercher",
    "searchPlaceholder": "titre ou description...",
    "refresh": "Actualiser",
    "loading": "Chargement des rapports de bugs…",
    "loadError": "Impossible de charger les rapports de bugs.",
    "table": {
      "empty": "Aucun rapport de bug ne correspond au filtre.",
      "title": "Titre",
      "status": "Statut",
      "priority": "Priorité",
      "category": "Catégorie",
      "reporter": "Rapporteur",
      "assignee": "Assigné à",
      "created": "Créé le",
      "occurrences": "Nombre"
    },
    "modal": {
      "close": "Fermer",
      "id": "ID :",
      "created": "Créé :",
      "seen": "Vu : {{count}}x",
      "auto": "auto",
      "statusLabel": "Statut",
      "assigneeLabel": "Assigné à (user_id)",
      "assigneePlaceholder": "ObjectId ou laisser vide",
      "save": "Enregistrer",
      "linked": "Liés",
      "merchant": "Marchand :",
      "vendor": "Vendeur :",
      "order": "Commande :",
      "sourceUrl": "Source URL :",
      "description": "Description",
      "noDescription": "(aucune description)",
      "stackTrace": "Trace de pile",
      "screenshots": "Captures d'écran ({{count}})",
      "comments": "Commentaires ({{count}})",
      "noComments": "Aucun commentaire pour le moment."
    },
    "create": {
      "button": "Nouveau bug",
      "heading": "Créer un rapport de bug",
      "titleLabel": "Titre",
      "titlePlaceholder": "Résumé court du problème",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Ce qui s'est passé, où, et comment le reproduire",
      "categoryLabel": "Catégorie",
      "priorityLabel": "Priorité",
      "assigneeLabel": "Responsable",
      "assigneePlaceholder": "ObjectId ou laisser vide",
      "submit": "Créer",
      "submitting": "Création…",
      "cancel": "Annuler",
      "titleRequired": "Le titre est obligatoire (2 caractères minimum).",
      "createError": "Impossible de créer le rapport de bug.",
      "manualHint": "Les rapports créés manuellement ne sont pas marqués comme auto-signalés.",
      "assigneeUnassigned": "Non assigné",
      "assigneeSearchPlaceholder": "Rechercher un admin par nom ou e-mail…",
      "assigneeSearching": "Recherche…",
      "assigneeNoResults": "Aucun admin correspondant"
    }
  },
  "kanban": {
    "regionAria": "Tableau Kanban du Bug Tracker",
    "columnAria": "Colonne {{label}}",
    "empty": "Aucun bug dans ce statut",
    "cardAria": "Bug : {{title}} ({{priority}})",
    "unassigned": "non assigné",
    "reporterTitle": "Rapporteur : {{name}}",
    "assigneeTitle": "Assigné à : {{name}}",
    "screenshotsAria": "{{count}} captures d'écran"
  },
  "listV2": {
    "refresh": "Actualiser",
    "newTicket": "Nouveau ticket",
    "searchPlaceholder": "Rechercher par n° de ticket, titre ou email...",
    "allStatuses": "Tous les statuts",
    "allCategories": "Toutes les catégories",
    "allChannels": "Tous les canaux",
    "allPriorities": "Toutes les priorités",
    "allTypes": "Tous les types",
    "allAssignees": "Tous les agents",
    "typeInternal": "Interne",
    "typeMerchant": "Marchand",
    "showingCount": "Affichage de {{shown}} sur {{total}} tickets",
    "showingRecords": "Affichage {{from}}-{{to}} sur {{total}} lignes",
    "selectAll": "Tout sélectionner",
    "selectRow": "Sélectionner la ligne",
    "viewDetail": "Voir le détail",
    "moreActions": "Plus d'actions",
    "stats": {
      "open": "Ouverts",
      "urgent": "Urgents",
      "overdueSla": "SLA dépassé",
      "resolvedToday": "Résolus aujourd'hui"
    },
    "columns": {
      "ticket": "N° Ticket",
      "type": "Type",
      "category": "Catégorie",
      "assigned": "Assigné",
      "lastUpdated": "Dernière MàJ",
      "actions": "Actions"
    },
    "quickFilters": {
      "heading": "Filtres rapides"
    },
    "assignSuccess": "Ticket assigné",
    "unassign": "Désassigner",
    "bulk": {
      "selectedCount": "{{count}} sélectionné(s)",
      "assign": "Assigner à…",
      "setStatus": "Changer le statut…",
      "setPriority": "Changer la priorité…",
      "markRead": "Marquer comme lu",
      "clear": "Effacer la sélection",
      "done": "{{ok}} mis à jour",
      "failed": "{{fail}} en échec",
      "skipped": "{{skipped}} ignoré(s) (transition invalide)"
    }
  },
  "newTicket": {
    "title": "Nouveau ticket",
    "subject": "Sujet",
    "description": "Description",
    "merchant": "Marchand",
    "merchantPlaceholder": "Rechercher un marchand par nom ou email...",
    "merchantLoading": "Recherche...",
    "merchantEmpty": "Aucun marchand trouvé.",
    "category": "Catégorie",
    "priority": "Priorité",
    "type": "Type de ticket",
    "cancel": "Annuler",
    "create": "Créer",
    "creating": "Création...",
    "created": "Ticket créé.",
    "createFailed": "Impossible de créer le ticket."
  },
  "detailV2": {
    "backToTickets": "Retour aux tickets",
    "notFound": "Ticket introuvable.",
    "issueDescription": "Description du problème",
    "conversation": "Conversation ({{count}} messages)",
    "noMessages": "Aucun message.",
    "internalNote": "Note interne",
    "internalNoteHint": "Note interne (visible uniquement par le staff)",
    "replyPlaceholder": "Saisissez votre message...",
    "sendReply": "Envoyer",
    "sendFailed": "Impossible d'envoyer le message.",
    "ticketStatus": "Statut du ticket",
    "assign": "Assigner",
    "escalate": "Escalader",
    "escalatedBadge": "Escaladé · Niveau {{level}}",
    "merchantInformation": "Informations marchand",
    "merchantOrders": "{{count}} commandes",
    "merchantLifetime": "{{amount}} cumulé",
    "resolution": "Résolution",
    "resolutionType": "Type de résolution",
    "resolutionNotes": "Notes de résolution",
    "resolve": "Résoudre",
    "ratingTitle": "Note du marchand",
    "activityLog": "Journal d'activité",
    "noActivity": "Aucune activité.",
    "createdAt": "Créé le",
    "updatedAt": "Mis à jour",
    "resolvedAt": "Résolu",
    "updated": "Ticket mis à jour.",
    "updateFailed": "Impossible de mettre à jour le ticket.",
    "vendorThread": "Fil vendeur — {{vendor}}",
    "vendorThreadHint": "Invisible pour le marchand",
    "vendorFallback": "Vendeur",
    "vendorReplyPlaceholder": "Écrire au vendeur...",
    "vendorStatusLabels": {
      "Pending": "Vendeur : en attente",
      "InProgress": "Vendeur : en cours",
      "Done": "Vendeur : terminé"
    },
    "relatedOrders": "Commandes liées",
    "noRelatedOrders": "Aucune commande liée",
    "linkOrderSearch": "Rechercher des commandes par numéro…",
    "linkOrderLink": "Lier",
    "linkOrderUnlink": "Délier",
    "linkOrderLinked": "Commandes liées",
    "linkOrderEmpty": "Aucune commande trouvée",
    "resolveNeedsOrder": "Liez la commande concernée avant de résoudre avec cette action.",
    "activity": {
      "escalated": "Escaladé",
      "dispatched": "Envoyé au fournisseur",
      "pushedToVendor": "Transmis au fournisseur",
      "dispatchCancelled": "Envoi annulé",
      "dispatchReturned": "Envoi retourné",
      "relatedOrdersSet": "Commandes liées",
      "merchantConfirmedClose": "Fermeture confirmée par le marchand",
      "vendorClosed": "Fermé par le fournisseur",
      "merchantReopened": "Rouvert par le marchand",
      "unassignedFallback": "Désassignation auto",
      "updated": "Mis à jour"
    },
    "permissionDenied": "Vous n'avez pas l'autorisation d'effectuer cette action.",
    "readByMerchant": "Lu par le marchand",
    "sentAwaitingRead": "Envoyé — pas encore lu",
    "pushToVendor": "Transférer au vendeur",
    "pushToDepartment": "Transférer au département",
    "activityFields": {
      "assignee": "Assigné",
      "status": "Statut",
      "priority": "Priorité",
      "category": "Catégorie"
    }
  },
  "pushVendor": {
    "cta": "Transférer au vendeur",
    "repush": "Transféré au vendeur",
    "title": "Transférer le ticket à un vendeur",
    "description": "Le vendeur reçoit les infos du ticket et un fil dédié. Il ne voit jamais la conversation marchand.",
    "vendor": "Vendeur",
    "vendorPlaceholder": "Choisir un vendeur...",
    "note": "Note de transfert",
    "notePlaceholder": "Contexte pour le vendeur (dans le fil vendeur)...",
    "confirm": "Transférer",
    "pushing": "Transfert...",
    "pushed": "Ticket transféré au vendeur.",
    "failed": "Impossible de transférer le ticket."
  },
  "resolutionLabels": {
    "Reprint": "Réimpression",
    "FullRefund": "Remboursement total",
    "PartialRefund": "Remboursement partiel",
    "StoreCredit": "Avoir boutique",
    "Replacement": "Remplacement",
    "ShippingCredit": "Avoir livraison",
    "NoActionRequired": "Aucune action requise",
    "Escalated": "Escaladé"
  },
  "inboxV2": {
    "title": "Boîte de réception",
    "chipAll": "Toutes",
    "chipOpen": "Ouvertes",
    "chipAssignedToMe": "Assignées à moi",
    "searchPlaceholder": "Rechercher des conversations...",
    "empty": "Aucune conversation.",
    "selectPrompt": "Sélectionnez une conversation pour commencer",
    "openTicket": "Ouvrir le ticket →",
    "unreadDot": "Non lu"
  },
  "performanceV2": {
    "heading": "Performance du support",
    "subtitle": "Analyser la performance des agents et la satisfaction des marchands",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "category": "Catégorie",
    "agent": "Agent",
    "rating": "Note",
    "allAgents": "Tous les agents",
    "allRatings": "Toutes les notes",
    "reset": "Réinitialiser",
    "totalRated": "Total noté",
    "averageRating": "Note moyenne",
    "satisfactionRate": "Taux de satisfaction",
    "satisfactionSub": "4-5 étoiles",
    "avgResponseTime": "Temps de réponse moyen",
    "leaderboard": "Classement des agents",
    "rank": "Rang",
    "agentCol": "Agent",
    "ticketsHandled": "Tickets traités",
    "ratingCol": "Note",
    "responseTime": "Temps de réponse",
    "slaBreach": "SLA dépassé",
    "noData": "Aucune donnée de performance",
    "ratingDistribution": "Répartition des notes",
    "categoryBreakdown": "Répartition par catégorie",
    "categoryCol": "Catégorie"
  },
  "configV2": {
    "heading": "Configurations du support",
    "subtitle": "Gérer les canaux et les paramètres des agents",
    "tabChannels": "Canaux",
    "tabAgents": "Agents",
    "totalConnections": "Connexions totales",
    "searchChannels": "Rechercher des canaux...",
    "addChannel": "Ajouter un canal",
    "saveChannel": "Enregistrer",
    "colName": "Nom",
    "colType": "Type",
    "colUpdated": "Dernière MàJ",
    "colActive": "Actif",
    "noChannels": "Aucun canal configuré. Ajoutez votre premier canal.",
    "channelCreated": "Canal ajouté.",
    "channelDeleted": "Canal supprimé.",
    "deleteChannel": "Supprimer le canal",
    "actionFailed": "Échec de l'action.",
    "channelTypes": {
      "webchat": "Webchat",
      "email": "Email",
      "ai_bot": "Bot IA",
      "staff": "Personnel"
    },
    "colAgent": "Agent",
    "colEmail": "Email",
    "colRole": "Rôle",
    "noAgents": "Aucun agent de support trouvé.",
    "colStatus": "Statut",
    "colCategories": "Catégories",
    "colLoad": "Charge",
    "colWorkingHours": "Heures de travail",
    "addAgent": "Ajouter un agent",
    "configure": "Configurer",
    "removeAgent": "Supprimer l'agent",
    "searchAgents": "Rechercher un agent par nom…",
    "availableAll": "Toute disponibilité",
    "categoryAll": "Toutes les catégories",
    "totalAgents": "Nombre total d'agents",
    "agentLoadError": "Impossible de charger la liste des agents.",
    "unassignedQueue": "File non attribuée",
    "unassignedTickets": "{{count}} ticket(s) non attribué(s) en attente d'attribution",
    "agentStatus": {
      "available": "Disponible",
      "unavailable": "Indisponible",
      "atCap": "Capacité atteinte",
      "outOfHours": "Hors des heures"
    },
    "pairBridge": "Associer une passerelle Facebook (Personnel)",
    "pairBridgeSubtitle": "Créez un canal passerelle et délivrez un jeton d'appareil à usage unique pour un runner headless.",
    "deviceToken": "Jeton d'appareil",
    "deviceTokenHint": "Copiez ce jeton maintenant — il n'est affiché qu'une seule fois.",
    "copyToken": "Copier le jeton",
    "tokenCopied": "Jeton copié",
    "revokeDevice": "Révoquer",
    "revokeConfirm": "Révoquer cet appareil ? Son jeton cesse de fonctionner immédiatement.",
    "devicesTitle": "Appareils associés",
    "colDeviceStatus": "État de l'appareil",
    "pairSuccess": "Passerelle associée. Copiez le jeton maintenant.",
    "pairFailed": "Échec de l'association.",
    "agentUserIdLabel": "ID utilisateur de l'agent",
    "channelNameLabel": "Nom du canal",
    "colMaxConcurrent": "Max"
  },
  "agentConfig": {
    "title": "Configurer l'agent — {{name}}",
    "available": "Disponible",
    "availableHint": "L'agent reçoit de nouvelles affectations de tickets",
    "workingHours": "Heures de travail",
    "timezone": "Fuseau horaire",
    "timezonePlaceholder": "ex. Asia/Ho_Chi_Minh",
    "windowsEmpty": "Aucune plage — disponible à tout moment.",
    "addWindow": "Ajouter une plage",
    "removeWindow": "Supprimer la plage",
    "day": "Jour",
    "startTime": "Début",
    "endTime": "Fin",
    "days": {
      "sun": "Dimanche",
      "mon": "Lundi",
      "tue": "Mardi",
      "wed": "Mercredi",
      "thu": "Jeudi",
      "fri": "Vendredi",
      "sat": "Samedi"
    },
    "categories": "Catégories",
    "categoriesHint": "Laissez tout décoché pour gérer toutes les catégories.",
    "maxConcurrent": "Tickets simultanés max",
    "maxConcurrentHint": "Laissez vide pour illimité.",
    "maxConcurrentPlaceholder": "Illimité",
    "channels": "Canaux",
    "channelsHint": "Sources de tickets gérées par cet agent.",
    "channelsEmpty": "Aucun canal configuré pour le moment.",
    "notifyChannels": "Canaux de notification",
    "notifyInApp": "Dans l'application",
    "notifyInAppHint": "Toujours actif",
    "notifyTargetPlaceholder": "ID de chat ou cible webhook",
    "notify": {
      "telegram": "Telegram",
      "lark": "Lark"
    },
    "save": "Enregistrer",
    "saving": "Enregistrement…",
    "cancel": "Annuler",
    "saved": "Configuration enregistrée.",
    "saveFailed": "Impossible d'enregistrer la configuration de l'agent."
  },
  "addAgent": {
    "title": "Ajouter un agent de support",
    "subtitle": "Choisissez un membre du personnel interne à ajouter à l'équipe de support.",
    "pickerLabel": "Membre du personnel",
    "searchPlaceholder": "Rechercher par nom ou e-mail…",
    "loading": "Chargement du personnel…",
    "noStaff": "Aucun membre du personnel interne disponible.",
    "noMatch": "Aucun membre ne correspond à \"{{query}}\".",
    "loadError": "Impossible de charger la liste du personnel.",
    "submit": "Ajouter l'agent",
    "submitting": "Ajout…",
    "cancel": "Annuler",
    "added": "Agent ajouté.",
    "addFailed": "Impossible d'ajouter l'agent."
  },
  "removeAgent": {
    "title": "Supprimer l'agent — {{name}}",
    "body": "L'agent sera désactivé et retiré de l'équipe de support. Le rôle de son compte n'est pas modifié.",
    "openTicketsCount": "{{count}} ticket(s) ouvert(s) seront réaffectés à d'autres agents disponibles avant la suppression.",
    "noOpenTickets": "Cet agent n'a aucun ticket ouvert — rien à réaffecter.",
    "confirm": "Supprimer l'agent",
    "removing": "Suppression…",
    "cancel": "Annuler",
    "removed": "Agent supprimé.",
    "removedWithReassign": "Agent supprimé. {{count}} ticket(s) réaffecté(s).",
    "removeFailed": "Impossible de supprimer l'agent.",
    "notFound": "Cet agent n'existe plus. La liste a été actualisée."
  },
  "realtime": {
    "newTicketTitle": "Nouveau ticket",
    "newTicketBody": "Un nouveau ticket requiert votre attention.",
    "tabFlash": "Nouveau ticket",
    "markRead": "Marquer comme lu",
    "markAllRead": "Tout marquer comme lu",
    "replyTitle": "Nouvelle réponse",
    "replyBody": "Un client a répondu à un ticket."
  },
  "routingRules": {
    "title": "Règles de routage",
    "subtitle": "Affectez automatiquement les tickets par catégorie, canal ou SLA. Les règles s'appliquent dans l'ordre.",
    "add": "Ajouter une règle de routage",
    "empty": "Aucune règle de routage. Ajoutez-en une pour router automatiquement les nouveaux tickets.",
    "loading": "Chargement des règles de routage…",
    "loadError": "Impossible de charger les règles de routage.",
    "edit": "Modifier",
    "delete": "Supprimer",
    "createTitle": "Nouvelle règle de routage",
    "editTitle": "Modifier la règle de routage",
    "typeLabel": "Type de condition",
    "matchLabel": "Valeur à faire correspondre",
    "matchPlaceholder": "ex. Billing, webchat ou un niveau de SLA",
    "targetKindLabel": "Cible",
    "agentsLabel": "Affecter aux agents",
    "agentsHint": "Les tickets correspondants sont routés vers les agents sélectionnés.",
    "agentsEmpty": "Aucun agent de support dans l'équipe pour le moment.",
    "escalateHint": "Les tickets correspondants sont escaladés vers l'équipe d'astreinte.",
    "orderLabel": "Ordre",
    "orderHint": "Les numéros plus petits sont évalués en premier.",
    "save": "Enregistrer la règle",
    "saving": "Enregistrement…",
    "cancel": "Annuler",
    "created": "Règle de routage créée.",
    "updated": "Règle de routage mise à jour.",
    "deleted": "Règle de routage supprimée.",
    "saveFailed": "Impossible d'enregistrer la règle de routage.",
    "deleteFailed": "Impossible de supprimer la règle de routage.",
    "matchRequired": "Saisissez une valeur à faire correspondre.",
    "agentsRequired": "Sélectionnez au moins un agent.",
    "targetAgentsSummary": "Affecter à {{count}} agent(s)",
    "targetEscalateSummary": "Escalader vers l'astreinte",
    "typeAll": "Tous les types",
    "typeFilterAria": "Filtrer par type de condition",
    "sortAria": "Trier les règles par",
    "sortOrder": "Ordre",
    "sortCreated": "Création",
    "dirAsc": "Croissant",
    "dirDesc": "Décroissant",
    "deleteConfirmTitle": "Supprimer la règle de routage ?",
    "deleteConfirmBody": "Cette règle sera supprimée et les tickets correspondants ne seront plus routés automatiquement.",
    "deleting": "Suppression…"
  },
  "routingType": {
    "category": "Catégorie",
    "channel": "Canal",
    "sla": "SLA"
  },
  "routingTarget": {
    "agents": "Affecter aux agents",
    "escalate": "Escalader"
  },
  "availability": {
    "available": "Disponible",
    "unavailable": "Indisponible",
    "toggleAria": "Basculer ma disponibilité",
    "tooltip": "Choisir de recevoir ou non de nouvelles affectations de tickets",
    "nowAvailable": "Vous êtes maintenant disponible pour de nouveaux tickets.",
    "nowUnavailable": "Vous êtes maintenant indisponible — les nouveaux tickets vous ignoreront.",
    "toggleFailed": "Impossible de mettre à jour votre disponibilité."
  },
  "channelType": {
    "webchat": "Chat web",
    "email": "E-mail",
    "ai_bot": "Bot IA",
    "staff": "Personnel",
    "facebook": "Facebook",
    "zalo": "Zalo",
    "telegram": "Telegram",
    "wechat": "WeChat",
    "facebook_personal": "Facebook (Personnel)",
    "zalo_personal": "Zalo (Personnel)",
    "lark": "Lark"
  },
  "channelStatus": {
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "error": "Erreur",
    "pending": "En attente"
  },
  "addChannel": {
    "title": "Ajouter un canal",
    "subtitle": "Connectez une plateforme sociale pour recevoir les messages de support.",
    "selectPlatform": "Sélectionner une plateforme",
    "platformLabel": "Plateforme",
    "nameLabel": "Nom d'affichage",
    "namePlaceholder": "ex. Page de support Printway",
    "next": "Suivant",
    "back": "Retour",
    "cancel": "Annuler",
    "connect": "Connecter",
    "connecting": "Connexion…",
    "verify": "Vérifier la connexion",
    "verifying": "Vérification…",
    "verified": "Connexion vérifiée.",
    "verifyFailed": "Impossible de vérifier la connexion. Vérifiez les identifiants et réessayez.",
    "wechatComingSoon": "L'intégration WeChat arrive bientôt et ne peut pas encore être connectée.",
    "created": "Canal connecté.",
    "createFailed": "Impossible de connecter le canal.",
    "steps": {
      "facebook": "Autorisez l'application Printway à accéder à votre page Facebook, puis collez le jeton d'accès de la page ci-dessous.",
      "zalo": "Autorisez l'application Official Account de Printway, puis indiquez votre identifiant OA Zalo et les identifiants de l'application.",
      "telegram": "Créez un bot avec @BotFather et collez le jeton du bot ci-dessous.",
      "lark": "Créez une app interne dans la console développeur Lark, activez le bot, puis collez l'App ID, l'App Secret et le jeton de vérification des Event Subscriptions. Après connexion, définissez l'URL d'abonnement aux événements sur <api>/api/v1/support/webhooks/lark et abonnez-vous à im.message.receive_v1."
    },
    "fields": {
      "pageId": "ID de page",
      "pageToken": "Jeton d'accès de la page",
      "oaId": "ID Official Account",
      "appId": "ID d'application",
      "appSecret": "Secret d'application",
      "botToken": "Jeton du bot",
      "botUsername": "Nom du bot",
      "accessToken": "Jeton d'accès",
      "refreshToken": "Jeton de rafraîchissement",
      "verificationToken": "Jeton de vérification"
    }
  },
  "reply": {
    "windowClosed": "Fenêtre de réponse fermée",
    "windowClosedHint": "La fenêtre de messagerie de 24 heures a expiré. Le client doit renvoyer un message avant que vous puissiez répondre.",
    "resend": "Renvoyer",
    "resending": "Renvoi…",
    "resent": "Message renvoyé.",
    "resendFailed": "Impossible de renvoyer le message."
  },
  "deliveryStatus": {
    "queued": "En file d'attente",
    "sending": "Envoi",
    "sent": "Envoyé",
    "delivered": "Distribué",
    "read": "Lu",
    "failed": "Échec",
    "undelivered": "Non distribué",
    "pending": "En attente",
    "blocked_window": "Fenêtre fermée"
  },
  "linkRequester": {
    "title": "Associer le demandeur à un marchand",
    "subtitle": "Associez ce contact social à un compte marchand.",
    "searchPlaceholder": "Rechercher par nom ou e-mail…",
    "loading": "Recherche…",
    "noMatch": "Aucun marchand ne correspond à « {{query}} ».",
    "link": "Associer",
    "linking": "Association…",
    "linked": "Demandeur associé.",
    "linkFailed": "Impossible d'associer le demandeur.",
    "unlink": "Dissocier",
    "unlinked": "Demandeur dissocié.",
    "currentlyLinked": "Associé à {{name}}",
    "searchHint": "Saisissez au moins 2 caractères pour rechercher des utilisateurs et des marchands.",
    "currentRequester": "Demandeur actuel",
    "externalUnknown": "Expéditeur inconnu",
    "platformUser": "ID de plateforme : {{id}}",
    "accountType": {
      "user": "Utilisateur",
      "merchant": "Marchand"
    },
    "confirmTitle": "Confirmer l'association",
    "confirmPrompt": "Associer l'expéditeur {{external}} de {{platform}} à {{account}} ?",
    "replaceWarning": "Cela remplacera le compte actuellement associé ({{name}}).",
    "confirm": "Confirmer l'association",
    "cancel": "Annuler",
    "back": "Retour",
    "retry": "Réessayer",
    "searchError": "Impossible de rechercher les comptes. Veuillez réessayer."
  },
  "channelActions": {
    "empty": "Aucun canal connecté pour le moment. Ajoutez-en un pour commencer à recevoir des messages.",
    "loadFailed": "Impossible de charger les canaux.",
    "reconnect": "Reconnecter",
    "disconnect": "Déconnecter",
    "disconnected": "Canal déconnecté.",
    "disconnectFailed": "Impossible de déconnecter le canal.",
    "deleteConfirm": "Supprimer ce canal ? Les conversations existantes sont conservées mais aucun nouveau message n'arrivera.",
    "deleted": "Canal supprimé.",
    "deleteFailed": "Impossible de supprimer le canal.",
    "verifyConnection": "Vérifier la connexion"
  },
  "socialThread": {
    "loadOlder": "Charger les messages plus anciens",
    "loadingOlder": "Chargement…",
    "empty": "Aucun message dans cette conversation pour le moment.",
    "loadError": "Impossible de charger la conversation.",
    "linkRequester": "Associer le demandeur",
    "attachmentDownload": "Télécharger la pièce jointe",
    "composerPlaceholder": "Saisissez votre réponse…",
    "composerSend": "Envoyer",
    "composerSending": "Envoi…",
    "composerAttach": "Joindre un fichier",
    "composerAttachRemove": "Retirer la pièce jointe",
    "composerNotSupported": "Les réponses ne sont pas encore prises en charge pour ce canal.",
    "composerSent": "Réponse envoyée.",
    "composerSendFailed": "Impossible d'envoyer la réponse.",
    "deliveryErrorCode": "Code d'erreur : {{code}}",
    "deviceOffline": "Le périphérique passerelle est hors ligne — les messages seront mis en file d'attente jusqu'à la reconnexion.",
    "deviceRevoked": "Ce périphérique passerelle a été révoqué — associez un nouveau périphérique pour reprendre."
  },
  "dispatch": {
    "title": "Transférer au vendeur / département",
    "target": {
      "vendor": "Vendeur",
      "department": "Département interne"
    },
    "department": {
      "Finance": "Finance",
      "IT": "Informatique",
      "Logistics": "Logistique",
      "Product": "Produit"
    },
    "status": {
      "Dispatched": "Transféré",
      "InProgress": "En cours",
      "Returned": "Retourné",
      "Cancelled": "Annulé"
    },
    "pickVendor": "Choisir un vendeur",
    "scopeNotePlaceholder": "Décrivez la tâche (aucune donnée personnelle du marchand pour les vendeurs)",
    "replyPlaceholder": "Répondre dans ce fil de transfert…",
    "submit": "Transférer",
    "cancel": "Annuler",
    "send": "Envoyer",
    "return": "Renvoyer au support",
    "recall": "Rappeler",
    "empty": "Aucun transfert",
    "navTitle": "File de transferts",
    "toast": {
      "created": "Transfert créé",
      "error": "Échec de l’action"
    },
    "titleVendor": "Transférer au vendeur",
    "titleDepartment": "Transférer au département",
    "scopeNoteLabel": "Note de périmètre"
  },
  "compose": {
    "keyboardHint": "Entrée pour envoyer · Option+Entrée pour une nouvelle ligne · Coller des images avec Ctrl+V",
    "attach": "Joindre un fichier",
    "uploading": "Téléversement…",
    "removeAttachment": "Retirer {{filename}}",
    "linkOrder": "Lier une commande",
    "searchOrder": "Rechercher une commande…",
    "noOrders": "Aucune commande trouvée",
    "uploadFailTitle": "Échec du téléversement",
    "fileTooLarge": "Le fichier dépasse la limite de 10 Mo",
    "fileTypeForbidden": "Ce type de fichier n'est pas autorisé",
    "download": "Télécharger",
    "imageAlt": "Image jointe",
    "attachDisabledHint": "Les pièces jointes ne sont disponibles que lorsque le dispatch est actif"
  },
  "stats": {
    "all": "Tous les tickets",
    "open": "Ouverts",
    "inProgress": "En cours",
    "awaitingHandler": "En attente du responsable",
    "pendingSupportReview": "En attente de révision",
    "resolved": "Résolus"
  },
  "quick": {
    "heading": "Actions rapides",
    "trackOrder": {
      "label": "Suivre la commande",
      "caption": "Vérifiez le statut ou la position d'une commande.",
      "subject": "Suivre ma commande",
      "description": "Je souhaite vérifier le statut et la position actuelle de ma commande. Numéro de commande : "
    },
    "startReturn": {
      "label": "Demander un retour",
      "caption": "Demandez un retour ou un remboursement pour une commande.",
      "subject": "Demander un retour",
      "description": "Je souhaite demander un retour ou un remboursement pour ma commande. Numéro de commande : \nMotif : "
    },
    "orderIssues": {
      "label": "Problème de commande",
      "caption": "Signalez un problème de produit ou de livraison.",
      "subject": "Problème avec ma commande",
      "description": "Je rencontre un problème avec un produit de ma commande. Numéro de commande : \nCe qui ne va pas : "
    },
    "paymentHelp": {
      "label": "Aide au paiement",
      "caption": "Obtenez de l'aide pour la facturation ou les paiements.",
      "subject": "Aide au paiement / facturation",
      "description": "J'ai besoin d'aide concernant un paiement ou une facturation. Veuillez décrire votre question : "
    }
  },
  "bridgeDeviceStatus": {
    "online": "En ligne",
    "offline": "Hors ligne",
    "revoked": "Révoqué"
  },
  "bugCategoryLabels": {
    "UI": "Interface",
    "Logic": "Logique",
    "Performance": "Performance",
    "Data": "Données",
    "Security": "Sécurité"
  }
}
